b
<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container-fluid">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										Loan Disbursed Reports
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="filterAction"
										:filter="filter"></report-filter>
									<b-button @click="printPDF" class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'print']" />
									</b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'download']" />
									</b-button>
								</div>
							</div>
						</div>
						<div class="card-body">
							<!-- <div class="row">
                  <div class="col-md-12">
                   
                  </div>
                </div> -->
							<div class="row" ref="pdfContent">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution"
										:title="'LOAN DISBURSED'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-6">
										<div class="small mb-2 fw-bold">
											TOTAL LOAN : {{ institution.currency_code }} {{
												displayNumber(total_loan)
											}}
										</div>
										<div class="small">
											<span class="fw-bold">Branch(es)</span> : {{ branch_list }}
										</div>

									</div>
									<div class="col-6 mt-auto">
										<div class="col-12 text-end">
											<!-- <div>
												Term:
												<span class="fw-bold">{{
													form.terms
												}}</span>
											</div> -->
											<span class="mt-2">From:
												<strong>{{
													form.start_date
												}}</strong>
												To:
												<strong>{{ form.end_date }}</strong>
											</span>
										</div>
									</div>
								</div>
								<div class="col-12 col-md-12 trans_details">
									<b-table striped bordered responsive id="loan-table" :busy.sync="isBusy"
										:items="items" :fields="fields" :tbody-tr-class="rowClass" show-empty>
										<template #table-busy>
											<div class="text-center text-danger my-2">
												<b-spinner class="align-middle"></b-spinner>
												<strong>Loading...</strong>
											</div>
										</template>
										<template #cell(fullname)="data">
											{{ data.item.customer.first_name }}
											{{ data.item.customer.last_name }}
										</template>
										<template #cell(loanperiod)="data">
											{{ data.item.tenor }}
											{{ data.item.tenor_interval }}
										</template>
									</b-table>
									<div class="d-flex justify-content-between pt-1 px-3 pb-3">
										<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
											:total-rows="totalRecords" :per-page="perPage"
											aria-controls="loan-table"></b-pagination>

										<div class="col text-end mt-1">
											<div>
												{{ currentPage }} - {{ perPage }} of
												{{ totalRecords }}
											</div>
											<b-form-group label="Per Page" label-size="sm" class="mb-0">
												<b-form-select @change="selectPerPage" id="per-page-select"
													v-model="perPage" :options="per_page_options"
													size="sm"></b-form-select>
											</b-form-group>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "../form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			form: {
				start_date: this.getBeginningOfYear(),
				end_date: new Date().toISOString().substr(0, 10),
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "Periodic",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				terms: false,
				coa: false,
				voucher_status: false,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			search: "Search",
			isBusy: false,
			isSearching: false,
			currentPage: 1,
			perPage: "10",
			per_page_options: ['10', '20', '50', '100', '200', '200', '500'],
			per_page_selected: "10",
			isLoadingInstitution: false,
			institution: "",
			totalRecords: 0,
			total_loan:0,
			fields: [
				{
					key: "start_date",
					label: "Disbursed Date",
				},
				// {
				//   key: "customer.last_name",
				//   label: "Customer Name",
				// },
				{
					key: "fullname",
					label: "Customer Name",
				},
				{
					key: "loan_number",
					label: "Loan #",
				},
				{
					key: "loan_product.name",
					label: "Loan Scheme",
				},
				{
					key: "principal_amount",
					label: "Principal",
				},
				{
					key: "expected_interest",
					label: "Exp. Interest",
				},
				{
					key: "interest_rate",
					label: "Int. Rate",
				},
				{
					key: "loanperiod",
					label: "Period",
				},
				{
					key: "maturity_date",
					label: "Due Date",
				},
				{
					key: "principal_paid",
					label: "Principal Paid",
				},
				{
					key: "interest_paid",
					label: "Interest Paid",
				},
				{
					key: "last_payment",
					label: "Last Paid",
				},
			],
			perPage: 20,
			currentPage: 1,
			items: [],
			branch_list:"",
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		sumPrincipalPaid() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total += this.items[i].principal_paid;
			}
			return total;
		},
		sumInterestPaid() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total += this.items[i].interest_paid;
			}

			return total;
		},
		sumPrincipalBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total += this.items[i].principal_balance;
			}

			return total;
		},
		sumInterestBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total += this.items[i].interest_balance;
			}

			return total;
		},
	},

	created() {
		this.getInstitution();
		this.loadItems();
	},
	methods: {
		rowClass() {
			return 'custom-row-height'
		},
		navigatePage(page) {
			// page is the new page number from <b-pagination>
			this.isBusy = true;
			this.currentPage = page;
			this.loadItems();
		},
		selectPerPage(value) {
			// value is the selected per-page (from b-form-select)
			this.perPage = Number(value);
			this.currentPage = 1; // reset to first page
			this.loadItems();
		},
		filterTable() {
			this.currentPage = 1;
			this.loadItems();
		},
		async loadItems() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;

			// Send page and per_page with the form payload
			const payload = {
				...this.form,
				page: this.currentPage,
				per_page: this.perPage,
			};

			try {
				const response = await ApiService.post("/reports/loans/disbursed", payload);

				// Laravel paginator is nested under response.data.data (because backend returned 'data' => $loans)
				const paginated = response.data?.data;

				// paginated.data -> array of items
				this.items = paginated?.data || [];
				// totals from paginator
				this.totalRecords = paginated?.total || 0;
				this.currentPage = paginated?.current_page || this.currentPage;
				this.perPage = paginated?.per_page ? Number(paginated.per_page) : this.perPage;
				this.total_loan = response.data?.totalLoan;

				// keep branch options and other top-level fields
				this.form.branch_options = response.data?.branches || this.form.branch_options;
				this.branch_list = this.form.branches.map((branch) => branch.name).join(", ");
			} catch (error) {
				console.error(error);
			} finally {
				this.isBusy = false;
				this.search = "Search";
				this.isSearching = false;
			}
		},
		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		filterAction() {
			this.loadItems();
		},
		changePerPageNumber(data) {
			this.perPage = data;
			this.loadItems();
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;
			const date =
				"FROM: " +
				this.form.start_date +
				" TO: " +
				this.form.end_date;
			const terms = "TERMS:  " + this.form.terms;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`M${institutionDetailsRow}`).value =
					institutionName;
				ws.getCell(`M${institutionDetailsRow}`).font = {
					bold: true,
					size: 14,
				}; // Bold and bigger font for name

				ws.getCell(`M${institutionDetailsRow + 1}`).value =
					institutionAddress;
				ws.getCell(`M${institutionDetailsRow + 1}`).font = {
					size: 12,
				}; // Regular font size for address

				ws.getCell(`M${institutionDetailsRow + 2}`).value =
					institutionMotto;
				ws.getCell(`M${institutionDetailsRow + 2}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`M${institutionDetailsRow + 3}`).value =
					institutionPhone;
				ws.getCell(`M${institutionDetailsRow + 3}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`M${institutionDetailsRow + 4}`).value =
					institutionEmail;
				ws.getCell(`M${institutionDetailsRow + 4}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`M${institutionDetailsRow + 6}`).value = date;
				ws.getCell(`M${institutionDetailsRow + 6}`).font = {
					size: 12,
				}; // Regular font size for phone

				ws.getCell(`M${institutionDetailsRow + 7}`).value = terms;
				ws.getCell(`M${institutionDetailsRow + 7}`).font = {
					size: 12,
				}; // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn("N").width = 50; // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Disbursed Date",
					"Customer Name",
					"Loan Number",
					"Loan Scheme",
					"Principal",
					"Exp. Interest",
					"Int. Rate",
					"Period",
					"Due Date",
					"Principal Paid",
					"Interest Paid",
					"Last Paid",
				];

				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				console.log(this.items[0]);
				this.items.forEach((item) => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.start_date,
						item.customer.first_name +
						" " +
						item.customer.last_name,
						item.loan_number,
						item.loan_product.name,
						item.principal_amount,
						item.expected_interest,
						item.interest_rate,
						item.loanperiod,
						item.maturity_date,
						item.principal_paid,
						item.interest_paid,
						item.last_payment,
					];
					// Apply text wrapping and center align for COA Name and COA Total columns
					row.getCell(4).alignment = {
						wrapText: true,
						vertical: "top",
						horizontal: "top",
					}; // COA Name
					row.getCell(5).alignment = {
						wrapText: true,
						vertical: "top",
						horizontal: "top",
					}; // COA Total

					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
				});

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "Loan_Disbursed.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
	},
};
</script>
